/* istanbul ignore file */
import { optional as codecOptional, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const PatchSectionDataParser = /* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ codecOptional(codecString)],
]);
export class PatchSectionData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PatchSectionDataParser.decode(input).map(res => new PatchSectionData(res));
    }
    static unsafeDecode(input) {
        return PatchSectionData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PatchSectionDataParser.encode(data);
    }
    static schema() {
        return PatchSectionDataParser.schema();
    }
}
